
import Vue from 'vue';

export function httpGetTokenOrderList(data) {
  return Vue.$axios({
    url: '/api/token/token/list',
    method: 'post',
    data
  })
}

export function httpCreateTokenOrder(data) {
  return  Vue.$axios({
    url: '/api/token/token/create',
    method: 'post',
    data
  })
}


